// extracted by mini-css-extract-plugin
export default {"checkbox":"styles_checkbox__c0Ouo","checkbox_unchecked":"styles_checkbox_unchecked__TeBJB","checked":"styles_checked__-RWcB","checkbox_disabled":"styles_checkbox_disabled__YLC-Y"};